import { jsonFetch } from "../../../lib/helpers";
import { RoomCustomer } from "../../../models/room";
import { getRoomsByUserIdUrl } from "./api-url.constants";
import { RoomsByUserIdApiDTO } from "./dtos/read-room.api.dto";
import { mapRoomsByUserId } from "./mappers/map-rooms-by-user-id.api.services";

export const getRoomsByUserId = async (userId: string): Promise<RoomCustomer[]> => {
  const response = await jsonFetch<RoomsByUserIdApiDTO>(getRoomsByUserIdUrl(userId));
  return response.data.rooms.map(mapRoomsByUserId);
};
